export default __webpack_public_path__ + "img/11aa1fb546a3fac65cc38f454a89db85.jpg";